import { formatDate, todayInMalaysia } from '@/lib/date'
import ConfirmDialog from '@/components/ui/ConfirmDialog'

/**
 * Asked before a pending order goes to production. Proceed cannot be undone
 * from the screen - the order leaves Pending and the first section is told -
 * so it is never a single click (client request 2026-10-13). Says so up
 * front when the production date has passed, since the server then re-plans
 * the order's sections from today.
 */
export default function ProceedConfirmDialog({
  order,
  onClose,
  onConfirm,
  loading,
}: {
  /** The order to proceed; null keeps the dialog shut. */
  order: { number: string; production_date?: string | null; section?: string | null } | null
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}) {
  const section = order?.section ?? 'the first section'
  const late = !!order?.production_date && order.production_date.slice(0, 10) < todayInMalaysia()

  return (
    <ConfirmDialog
      open={!!order}
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      title={`Proceed ${order?.number ?? ''} to production?`}
      confirmLabel="Proceed"
    >
      <p>
        It leaves Pending and goes into {section}'s queue, and {section} is told. It cannot be put back to Pending.
      </p>
      {late && (
        <p className="mt-2 font-semibold text-warning">
          Its production date ({formatDate(order?.production_date)}) has passed, so its sections are re-planned from today.
          A delivery date chosen by hand stays; otherwise the delivery date may move later and the customer is emailed.
        </p>
      )}
    </ConfirmDialog>
  )
}
